
export function validateIntentName (intentName: string) : boolean {
  return /^[A-Z][A-Z0-9_]*$/.test(intentName);
}

export function validateIntentInput (intentName: string) : boolean {
  return /^([A-Z]|[a-z])(\s|\w)*$/.test(intentName);
}
